import { Injectable } from '@angular/core';
import { HttpServiceService } from './http-service.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
 
  public NationalityURL: string= 'Country/GetAllActive';
  constructor(private http:HttpServiceService, private config:ConfigService) { }


  Nationality(UniqueId){

    return new Promise((resolve,reject)=>{
      this.http.postToOpenApi(this.config.server + this.NationalityURL,{UniqueId:UniqueId}).subscribe((res:any)=>{
        console.log('Nationality',res);

        resolve(res);
      },
      (Error)=>{
        resolve(Error);
      })
    })
  }
}
